module.exports = __webpack_public_path__ + "img/p-c5.aa9f2da0.png";